<template>
    <div class="alphatab-component">

        <div class="progress" v-show="loading">
            <div class="progress-bar" :id="id + '-progressbar'" role="progressbar" style="width: 0%" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

        <nav class="navbar navbar-expand navbar-dark bg-primary fixed-bottom alphatab-toolbar" :class="{ 'open': toolbarOpen }" v-show="!loading">
            <div class="container-lg">

                <div class="collapse navbar-collapse">

                    <div class="playback-controls">

                        <button type="button" class="btn btn-secondary navbar-btn mr-2" :class="{ 'btn-secondary': isPaused, 'btn-success': !isPaused }" @click="onPlayClick">
                            <IconifyIcon v-if="isPaused" icon="play" height="16" />
                            <IconifyIcon v-if="!isPaused" icon="pause" height="16" />
                        </button>

                        <button type="button" class="btn btn-danger navbar-btn mr-3" @click="onStopClick">
                            <IconifyIcon icon="stop" height="16" />
                        </button>

                        <button type="button" class="btn btn-primary navbar-btn toggle-toolbar" @click="toggleToolbar">
                            <IconifyIcon v-if="!toolbarOpen" icon="arrow-up" height="16" />
                            <IconifyIcon v-if="toolbarOpen" icon="arrow-down" height="16" />
                        </button>

                    </div>

                    <div class="feature-controls">

                        <button class="btn mr-2" :class="{ 'btn-success': isLooping, 'btn-light': !isLooping }" @click="setLooping(!isLooping)" data-toggle="tooltip" data-placement="top" title="" data-original-title="Herhalen">
                            <IconifyIcon icon="loop" height="16" />
                        </button>

                        <button class="btn mr-2" :class="{ 'btn-success': isAutoScrolling, 'btn-light': !isAutoScrolling }" @click="setAutoScroll(!isAutoScrolling)" data-toggle="tooltip" data-placement="top" title="" data-original-title="Automatisch scrollen">
                            <IconifyIcon icon="autoscroll" height="16" />
                        </button>

                        <button class="btn mr-3" :class="{ 'btn-success': countInEnabled, 'btn-light': !countInEnabled }" @click="toggleCountIn()" data-toggle="tooltip" data-placement="top" title="" data-original-title="Aftellen">
                            <IconifyIcon icon="countin" height="16" />
                        </button>

                    </div>

                    <div class="playback-tempo">
                        <!-- <button type="button" class="btn btn-light navbar-btn" @click="setAutoScroll(!isAutoScrolling)">
                            {{ isAutoScrolling ? 'Disable' : 'Enable' }} Auto Scroll
                        </button>
                        <button type="button" class="btn btn-light navbar-btn" @click="setLooping(!isLooping)">
                            {{ isLooping ? 'Disable' : 'Enable' }} Looping
                        </button> -->

                        <div class="alphatab-toolbar-range d-inline m-0 mr-2">
                            <!-- <label for="customRange1">Speed slider</label> -->
                            <input type="range" class="custom-range" id="customRange1" min="40" max="500" step="1" v-model="playbackTempo" @input="setPlaybackTempo(playbackTempo)">

                            <div class="bpm">
                                <input type="text" v-model="playbackTempo" @input="onPlaybackTempoInputChange()" @blur="setPlaybackTempo(playbackTempo)"> bpm
                                <!-- {{ playbackTempo }} bpm -->
                            </div>
                        </div>

                        <button class="btn btn-light mr-3" @click="setPlaybackTempo(targetTempo)" :disabled="targetTempo == playbackTempo" data-toggle="tooltip" data-placement="top" title="" data-original-title="BPM resetten">
                            <IconifyIcon icon="reset" height="16" />
                        </button>

                    </div>

                    <div class="break"></div>

                    <div class="alphatab-toolbar-volume d-inline m-0 mr-2">
                        <IconifyIcon v-if="playbackVolume >= 50" icon="volume-high" height="32" />
                        <IconifyIcon v-if="playbackVolume > 5 && playbackVolume < 50" icon="volume-low" height="32" />
                        <IconifyIcon v-if="playbackVolume <= 5" icon="volume-off" height="32" />
                        <div class="vertical-range-popup">
                            <input type="range" orient="vertical" class="d-none d-xl-inline-block custom-range" id="customRangePlaybackVolume" min="0" max="100" step="1" v-model="playbackVolume" @input="setPlaybackVolume(playbackVolume)">
                            <input type="range" class="d-xl-none custom-range" id="customRangePlaybackVolume2" min="0" max="100" step="1" v-model="playbackVolume" @input="setPlaybackVolume(playbackVolume)">
                        </div>
                    </div>

                    <div class="alphatab-toolbar-volume d-inline m-0 mr-2">
                        <IconifyIcon v-if="metronomeVolume <= 0" icon="metronome-off" height="32" />
                        <IconifyIcon v-if="metronomeVolume > 0" icon="metronome-on" height="32" />
                        <div class="vertical-range-popup">
                            <input type="range" orient="vertical" class="d-none d-xl-inline-block custom-range" id="customRangeMetronomeVolume" min="0" max="100" step="1" v-model="metronomeVolume" @input="setMetronomeVolume(metronomeVolume)">
                            <input type="range" class="d-xl-none custom-range" id="customRangeMetronomeVolume2" min="0" max="100" step="1" v-model="metronomeVolume" @input="setMetronomeVolume(metronomeVolume)">
                        </div>
                    </div>

                    <div class="tracks">


                        <div class="btn-group mr-2" role="group" aria-label="Second group">
                            <div v-for="(track, trackIndex) in trackSettings" class="volume-button">
                                <button class="btn text-nowrap pl-2 pr-1" :class="{ 'btn-success': !track.muted, 'btn-danger': track.muted }" @click="setTrackMute(trackIndex, !track.muted)">
                                    {{ parseInt(trackIndex) + 1 }} <IconifyIcon icon="note" height="16" />

                                </button>
                                <div class="vertical-range-popup">
                                    <input type="range" orient="vertical" class="d-none d-xl-inline-block custom-range" min="0" max="100" step="1" v-model="track.volume" @input="setTrackPlaybackVolume(trackIndex, track.volume)">
                                    <input type="range" class="d-xl-none custom-range" min="0" max="100" step="1" v-model="track.volume" @input="setTrackPlaybackVolume(trackIndex, track.volume)">
                                </div>
                            </div>
                            <!-- <button class="btn text-nowrap px-2 display-button" :class="{ 'btn-success': track.visible, 'btn-danger': !track.visible }" @click="setTrackVisibility(trackIndex, !track.visible)">
                                <IconifyIcon icon="eye" height="16" />
                            </button> -->
                        </div>

                        <button v-if="tracks != 'all'" class="btn text-nowrap px-2 display-button" :class="{ 'btn-success': secondaryTracksVisible, 'btn-danger': !secondaryTracksVisible }" @click="toggleSecondaryTracks()">
                            <IconifyIcon icon="eye" height="16" />
                        </button>
                            
                        <!--
                        <button v-for="(track, trackIndex) in trackSettings" class="btn text-nowrap mr-2" :class="{ 'btn-success': !track.muted, 'btn-danger': track.muted }" @click="setTrackMute(trackIndex, !track.muted)">
                            <IconifyIcon icon="note" height="16" />
                            {{ parseInt(trackIndex) + 1 }}
                        </button>


                        <div v-for="(track, trackIndex) in trackSettings" class="alphatab-toolbar-volume d-inline m-0 mr-2">
                            <IconifyIcon v-if="track.volume >= 50" icon="volume-high" height="32" />
                            <IconifyIcon v-if="track.volume > 5 && track.volume < 50" icon="volume-low" height="32" />
                            <IconifyIcon v-if="track.volume <= 5" icon="volume-off" height="32" />
                            <div>
                                <input type="range" class="custom-range" min="0" max="100" step="1" v-model="track.volume" @input="setTrackPlaybackVolume(trackIndex, track.volume)">
                            </div>
                        </div>
                        -->

                        <!-- <div v-if="alphatab && alphatab.score">
                        <div v-for="track in alphatab.score.tracks">
                            {{ track.PlaybackInfo.Volume }}
                        </div>
                        </div>
                        -->

                    </div>
                </div>

            </div>
        </nav>

        <div :id="id"></div>

    </div>
</template>

<script>
    export default {
        name: "AlphaTabComponent",
        props: [
            'file',
            'tracks',
            'soundFont',
            'barsPerRow',
            'alphatabSettings',
        ],
        components: {
        },
        data() {
            return {
                id: null,
                alphatabEl: null,
                alphatab: null, // API

                toolbarOpen: false,
                loading: true,

                currentTempo: 120,
                targetTempo: 120,
                playbackTempo: 120,
                playbackSpeed: 1,

                playbackVolume: 100,
                metronomeVolume: 0,
                countInEnabled: true,
                secondaryTracksVisible: false,

                mutes: {},
                trackSettings: {},

                onPlaybackTempoInputChange: function() {}
            }
        },
        created() {
            $(window).keypress((e) => {
                if (e.defaultPrevented) {
                    return;
                }

                if ($(e.target).is('input')) {
                    return;
                }

                switch (e.key) {
                    case ' ':
                        this.onPlayClick();
                        return false;
                    case 's':
                        this.onStopClick();
                        return false;
                    case 'h':
                        this.setLooping(!this.getIsLooping());
                        return false;
                    case 'v':
                        this.setAutoScroll(!this.getIsAutoScrolling());
                        return false;
                    case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
                        this.toggleTrackMute(e.key - 1);
                        return false;
                    default:
                        // console.log(e.key);
                        break;
                }
            });

            this.onPlaybackTempoInputChange = _.debounce(() => {
                this.setPlaybackTempo(this.playbackTempo);
            }, 1500);
        },
        mounted() {
            const barsPerRowTreshhold = 992;

            this.id = "alphatab-" + this._uid;

            $(() => {
                this.alphatabEl = $('#' + this.id);

                const defaultAlphatabSettings = {
                    file: this.file,
                    tracks: this.tracks,
                    countInVolume: 1,
                    player: {
                        enablePlayer: true,
                        soundFont: this.soundFont,
                        // offset: this.playerOffset,
                        scrollMode: 1,
                    },
                    display: {
                        barsPerRow: this.barsPerRow && $(window).width() >= barsPerRowTreshhold ? this.barsPerRow : -1,
                        StaveProfile: 'score'
                        // barsPerRow: 8,
                        // scale: 1
                    },
                    notation: {
                        elements: {
                            scoreTitle: false,
                            scoreSubTitle: false,
                            scoreArtist: false,
                            scoreWords: false,
                            scoreMusic: false,
                            scoreWordsAndMusic: false,
                            scoreCopyright: false,
                            trackNames: false,
                            EffectTempo: false,
                            GuitarTuning: false,
                        },
                    },
                };

                let alphatabSettings = _.merge(defaultAlphatabSettings, this.alphatabSettings ? this.alphatabSettings :{});

                this.alphatab = new alphaTab.AlphaTabApi(this.alphatabEl[0], alphatabSettings);

                // console.log(this.alphatab);

                this.alphatab.soundFontLoad.on((e) => {
                    const percentage = Math.floor((e.loaded / e.total) * 100);
                    $('#' + this.id + '-progressbar').css('width', percentage + '%');
                });

                this.alphatab.playerReady.on(() => {
                    this.alphatab.metronomeVolume = this.metronomeVolume / 100;
                    this.alphatab.countInVolume = this.countInEnabled ? this.playbackVolume / 100 : 0;
                });
                // this.alphatab.soundFontLoaded.on(() => {
                this.alphatab.renderFinished.on(() => {
                    this.loading = false;
                    this.currentTempo = this.alphatab.score.tempo;
                    if (this.alphatab.score.masterBars[0].tempoAutomation) {
                        this.targetTempo  = this.alphatab.score.masterBars[0].tempoAutomation.value;
                    }
                    this.playbackTempo = this.targetTempo;
                    this.setPlaybackTempo(this.playbackTempo);

                    // console.log(this.alphatab.score.tracks);
                    for (let trackIndex = 0; trackIndex < this.alphatab.score.tracks.length; trackIndex++) {
                        this.$set(this.mutes, trackIndex, false);
                        let volume = (this.alphatab.score.tracks[trackIndex].playbackInfo.volume / 16) * 100;

                        this.$set(this.trackSettings, trackIndex, {
                            muted: false,
                            volume: volume,
                            visible: false
                        });
                        this.setTrackPlaybackVolume(trackIndex, volume);
                    }
                    for (let i = 0; i < this.alphatab.tracks.length; i++) {
                        let trackSetting = this.trackSettings[this.alphatab.tracks[i].index];
                        trackSetting.visible = true;
                        this.$set(this.trackSettings, this.alphatab.tracks[i].index, trackSetting);
                    }
                    // this.setPlaybackSpeed(1);
                });

                if (this.barsPerRow > 0) {
                    const $window = $(window);
                    $window.on('resize', _.throttle((e) => {
                        let bpr = this.barsPerRow;

                        if ($window.width() < barsPerRowTreshhold) {
                            bpr = -1;
                        }

                        this.alphatab.settings.display.barsPerRow = bpr;
                        this.alphatab.updateSettings();
                        this.alphatab.render();
                    }, 250));
                }
            });
        },
        methods: {

            toggleToolbar() {
                this.toolbarOpen = !this.toolbarOpen;
            },

            onPlayClick() {
                // this.alphatab.alphaTab('playPause');
                this.alphatab.playPause();
            },

            onStopClick() {
                this.alphatab.stop();
            },

            onPauseClick() {
                this.alphatab.playPause();
            },

            /*setPlaybackSpeed(speed) {
                speed = Math.min(5, Math.max(0.1, speed));
                this.playbackSpeed = speed;
                this.alphatab.playbackSpeed = (((1 / this.currentTempo) * this.targetTempo) / 100) * (speed * 100);
            },*/

            setPlaybackTempo(tempo) {
                tempo = Math.min(500, Math.max(40, tempo));
                this.playbackTempo = tempo;

                this.alphatab.playbackSpeed = ((1 / this.currentTempo) * this.playbackTempo);
                // this.alphatab.playbackSpeed = (((1 / this.currentTempo) * this.targetTempo) / 100) * (speed * 100);
            },

            setPlaybackVolume(volume) {
                volume = Math.min(100, Math.max(0, volume));
                this.playbackVolume = volume;

                this.alphatab.changeTrackVolume(this.alphatab.score.tracks, volume / 100);
                // this.alphatab.masterVolume = volume / 100;

                if (this.countInEnabled) {
                    this.alphatab.countInVolume = Math.min(100, Math.max(0, this.playbackVolume)) / 100;
                }
            },

            setMetronomeVolume(volume) {
                volume = Math.min(100, Math.max(0, volume));
                this.metronomeVolume = volume;

                this.alphatab.metronomeVolume = volume / 100;

                /* let isPlaying = this.alphatab.playerState != 0;

                if (isPlaying) {
                    this.alphatab.pause();
                }
                this.alphatab.metronomeVolume = volume / 100;
                if (isPlaying) {
                    this.alphatab.play();
                } */
            },

            setAutoScroll(scroll) {
                this.alphatab.settings.player.scrollMode = scroll ? 1 : 0;
            },

            setLooping(looping) {
                this.alphatab.isLooping = looping;
            },

            toggleCountIn() {
                this.countInEnabled = !this.countInEnabled;

                if (this.countInEnabled) {
                    this.alphatab.countInVolume = Math.min(100, Math.max(0, this.playbackVolume)) / 100;
                } else {
                    this.alphatab.countInVolume = 0;
                }
            },

            toggleTrackMute(trackIndex) {
                if (!this.trackSettings.hasOwnProperty(trackIndex)) {
                    return;
                }

                this.setTrackMute(trackIndex, !this.trackSettings[trackIndex].muted);
            },

            setTrackMute(trackIndex, mute) {

                // this.trackSettings[trackIndex] = mute;
                let trackSetting = this.trackSettings[trackIndex];
                trackSetting.muted = mute;
                this.$set(this.trackSettings, trackIndex, trackSetting);
                // this.alphatab.changeTrackMute([trackIndex], mute);
                // this.alphatab.changeTrackMute(this.alphatab.score.tracks, mute);
                this.alphatab.changeTrackMute([this.alphatab.score.tracks[trackIndex]], mute);
                // console.log(this.alphatab.tracks[trackIndex].playbackInfo.isMute);
            },

            setTrackPlaybackVolume(trackIndex, volume) {
                // console.log(trackIndex, volume);
                this.alphatab.changeTrackVolume([this.alphatab.score.tracks[trackIndex]], volume / 100);
            },

            setTrackVisibility(trackIndex, visible) {
                let trackSetting = this.trackSettings[trackIndex];
                trackSetting.visible = visible;
                this.$set(this.trackSettings, trackIndex, trackSetting);

                let visibleTracks = [];
                for (let index in this.trackSettings) {
                    if (this.trackSettings[index].visible) {
                        visibleTracks.push(this.alphatab.score.tracks[index]);
                    }
                }

                if (visibleTracks.length > 0) {
                    this.alphatab.renderTracks(visibleTracks);
                } else {
                    trackSetting.visible = true;
                    this.$set(this.trackSettings, trackIndex, trackSetting);
                }
            },

            toggleSecondaryTracks() {
                this.secondaryTracksVisible = !this.secondaryTracksVisible;
                if (this.secondaryTracksVisible) {
                    for (let index in this.trackSettings) {
                        let trackSetting = this.trackSettings[index];
                        trackSetting.visible = true;
                        this.$set(this.trackSettings, index, trackSetting);
                    }
                } else {
                    for (let index in this.trackSettings) {
                        let trackSetting = this.trackSettings[index];
                        trackSetting.visible = false;
                        this.$set(this.trackSettings, index, trackSetting);
                    }

                    for (let index of JSON.parse(this.tracks)) {
                        let trackSetting = this.trackSettings[index];
                        trackSetting.visible = true;
                        this.$set(this.trackSettings, index, trackSetting);
                    }
                }

                let visibleTracks = [];
                for (let index in this.trackSettings) {
                    if (this.trackSettings[index].visible) {
                        visibleTracks.push(this.alphatab.score.tracks[index]);
                    }
                }

                if (visibleTracks.length > 0) {
                    this.alphatab.renderTracks(visibleTracks);
                } else {
                    trackSetting.visible = true;
                    this.$set(this.trackSettings, trackIndex, trackSetting);
                }
            },

            getIsPaused() {
                if (this.loading) return true;
                return this.alphatab.playerState == 0;
            },

            getIsLooping() {
                if (this.loading) return false;
                return this.alphatab.isLooping;
            },

            getIsAutoScrolling() {
                if (this.loading) return false;
                return this.alphatab.settings.player.scrollMode != 0;
            },

        },
        computed: {

            isPaused() {
                return this.getIsPaused();
            },

            isLooping() {
                return this.getIsLooping();
            },

            isAutoScrolling() {
                return this.getIsAutoScrolling();
            },

        }

    }
</script>

<style scoped>
</style>
